import { jsx as e } from "react/jsx-runtime";
import { forwardRef as c } from "react";
import m from "../../utils/classNames.js";
const d = c((a, o) => {
  const { className: r, children: s, ...i } = a, t = m("ApplicationLayoutSidebar", r);
  return /* @__PURE__ */ e("div", { ref: o, ...i, className: t, children: s });
});
export {
  d as default
};
//# sourceMappingURL=ApplicationLayoutSidebar.js.map
